/**
 * WebRuntime - Runtime with web/browser audio transport
 *
 * Simple subclass that provides web audio dependencies.
 * Server sync and reactive store are separate modules.
 */

import { Runtime } from '../Runtime';
import { getWebEnv, closeWebAudioContext } from '@/env/web/AudioContext';
import { RuntimeStore } from '../RuntimeStore';

export class WebRuntime extends Runtime {
  constructor(store: RuntimeStore) {
    super(store,getWebEnv());
  }

  /**
   * Dispose runtime and close audio context
   */
  dispose(): void {
    super.dispose();
    closeWebAudioContext();
  }
}
